define(["jquery", "mage/storage"], ($, storage) => {
  class WishlistHeaderQuantity {
    /**
     * Constructor
     *
     * @param {Object}  config  Configuration options passed in through JSON
     * @param {Element} element The element that this class was bound to
     *
     * @returns {null}
     */
    constructor(config, element) {
      const defaultConfig = {};
      // Merge default config options and provided config
      /** @type {Object} */
      this.config = { ...defaultConfig, ...config };

      this.$element = $(element);

      this.fetchQuantity();
    }

    fetchQuantity() {
      const wishlistQuery = `
        {
          wishlist {
              items_count
          }
        }
      `;

      const self = this;
      storage
        .post(
          "/graphql",
          JSON.stringify({ query: wishlistQuery }),
          true,
          "application/json",
          {
            Store: window.bbntStoreCode,
          }
        )
        .done(function (response) {
          if (!response.errors) {
            self.onQuantity(response);
          }
        })
        .fail(function () {});
    }

    onQuantity(response) {
      let itemsCount = 0;
      if (
        response &&
        response.data &&
        response.data.wishlist &&
        response.data.wishlist.items_count
      ) {
        itemsCount = response.data.wishlist.items_count;
      }

      const $wishlistHeaderContainer = $(".wishlist-header-container");
      const $counterQty = $wishlistHeaderContainer.find(".counter.qty");
      const $counterValue = $counterQty.find(".value");
      $counterValue.html(`${itemsCount}`);
      if (itemsCount > 0) {
        $counterQty.removeClass("empty");
      } else {
        $counterQty.addClass("empty");
      }
    }
  }

  return (config, element) => {
    const wishlistHeaderQuantity = new WishlistHeaderQuantity(config, element);
    return wishlistHeaderQuantity;
  };
});
